import { CampaignsApi } from '../clients';
import { mapPromoCode } from '../mappers';

/**
 * One promo code for the detail page.
 *
 * A 404 is a legitimate answer — a deleted or mistyped id — so it resolves to
 * null and the page renders a not-found state. Everything else propagates, so
 * a 403 or 500 surfaces as an error rather than masquerading as not-found.
 */
export const getPromoCode = async (campaignId) => {
  try {
    return mapPromoCode(await CampaignsApi.getCampaign(campaignId));
  } catch (error) {
    if (error?.response?.status === 404) return null;

    throw error;
  }
};
